<app-cliente-modal [isOpen]="isClienteModalOpen" (closeModal)="closeClienteModal($event)"></app-cliente-modal>
<app-orcamento-modal [isOpen]="isOrcamentoModalOpen" (closeModal)="closeOrcamentoModal($event)"></app-orcamento-modal>

<section class="agendamento-shell">
  <header class="agendamento-hero">
    <div>
      <h2 class="agendamento-title">{{ isEditMode ? 'Editar Agendamento' : 'Novo Agendamento' }}</h2>
      <p class="agendamento-subtitle">
        Registre os detalhes do agendamento.
        Campos marcados com <span class="text-danger">*</span> são obrigatórios.
      </p>
    </div>
    <span class="agendamento-chip">{{ isEditMode ? 'Edição' : 'Cadastro' }}</span>
  </header>

  <form [formGroup]="agendamentoForm" (ngSubmit)="save()" id="agendamentoForm" class="agendamento-card">
    <div class="form-section">
      <h3>Dados do Agendamento</h3>
      <div class="row g-3">
        <div class="col-md-6">
          <label for="tipoAgendamento" class="form-label">Tipo de Agendamento <span class="text-danger">*</span></label>
          <select
            id="tipoAgendamento"
            class="form-select"
            formControlName="tipoAgendamento"
            [class.is-invalid]="agendamentoForm.get('tipoAgendamento')?.invalid && agendamentoForm.get('tipoAgendamento')?.touched"
          >
            <option value="">Selecione um tipo</option>
            <option *ngFor="let option of tipoAgendamentoOptions" [value]="option.valorMaximo">
              {{ option.valorMaximo }}
            </option>
          </select>
          <div class="invalid-feedback" *ngIf="agendamentoForm.get('tipoAgendamento')?.invalid && agendamentoForm.get('tipoAgendamento')?.touched">
            <span *ngIf="agendamentoForm.get('tipoAgendamento')?.errors?.['required']">Campo obrigatório.</span>
          </div>
        </div>

        <div class="col-md-6">
          <label for="dataAgendamento" class="form-label">Data do Agendamento <span class="text-danger">*</span></label>
          <input
            id="dataAgendamento"
            class="form-control"
            type="datetime-local"
            formControlName="dataAgendamento"
            [class.is-invalid]="agendamentoForm.get('dataAgendamento')?.invalid && agendamentoForm.get('dataAgendamento')?.touched"
          >
          <div class="invalid-feedback" *ngIf="agendamentoForm.get('dataAgendamento')?.invalid && agendamentoForm.get('dataAgendamento')?.touched">
            <span *ngIf="agendamentoForm.get('dataAgendamento')?.errors?.['required']">Data obrigatória.</span>
          </div>
        </div>

        <div class="col-md-6">
          <label for="nomeCliente" class="form-label">Cliente <span class="text-danger">*</span></label>
          <div class="input-group">
            <input
              id="nomeCliente"
              class="form-control"
              type="text"
              [value]="clienteSelecionado?.nomeRazaoSocial"
              placeholder="Selecione um cliente"
              readonly
              [class.is-invalid]="!clienteSelecionado?.id"
              style="background-color: #e9ecef;"
            >
            <button class="btn btn-outline-secondary" type="button" (click)="incluirCliente()">
              <i class="bi bi-search"></i> Buscar
            </button>
          </div>
          <div class="invalid-feedback" *ngIf="!clienteSelecionado?.id" style="display: block;">
            Selecione um cliente.
          </div>
        </div>

        <div class="col-md-6">
          <label for="telefoneContato" class="form-label">Telefone de Contato <span class="text-danger">*</span></label>
          <input
            id="telefoneContato"
            class="form-control"
            type="text"
            mask="(00) 00000-0000"
            formControlName="telefoneContato"
            [class.is-invalid]="agendamentoForm.get('telefoneContato')?.invalid && agendamentoForm.get('telefoneContato')?.touched"
          >
          <div class="invalid-feedback" *ngIf="agendamentoForm.get('telefoneContato')?.invalid && agendamentoForm.get('telefoneContato')?.touched">
            <span *ngIf="agendamentoForm.get('telefoneContato')?.errors?.['required']">Telefone obrigatório.</span>
            <span *ngIf="agendamentoForm.get('telefoneContato')?.errors?.['minlength']">Telefone inválido.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="enderecoAgendamento" class="form-label">Endereço do Agendamento <span class="text-danger">*</span></label>
          <input
            id="enderecoAgendamento"
            class="form-control"
            type="text"
            formControlName="enderecoAgendamento"
            [class.is-invalid]="agendamentoForm.get('enderecoAgendamento')?.invalid && agendamentoForm.get('enderecoAgendamento')?.touched"
          >
          <div class="invalid-feedback" *ngIf="agendamentoForm.get('enderecoAgendamento')?.invalid && agendamentoForm.get('enderecoAgendamento')?.touched">
            <span *ngIf="agendamentoForm.get('enderecoAgendamento')?.errors?.['required']">Endereço obrigatório.</span>
            <span *ngIf="agendamentoForm.get('enderecoAgendamento')?.errors?.['minlength']">Mínimo de 5 caracteres.</span>
          </div>
        </div>

        <div class="col-md-6">
          <label for="complexidade" class="form-label">Complexidade <span class="text-danger">*</span></label>
          <select
            id="complexidade"
            class="form-select"
            formControlName="complexidade"
            [class.is-invalid]="agendamentoForm.get('complexidade')?.invalid && agendamentoForm.get('complexidade')?.touched"
          >
            <option value="">Selecione uma complexidade</option>
            <option *ngFor="let option of complexidadeOptions" [value]="option.valorMinimo">
              {{ option.valorMaximo }}
            </option>
          </select>
          <div class="invalid-feedback" *ngIf="agendamentoForm.get('complexidade')?.invalid && agendamentoForm.get('complexidade')?.touched">
            <span *ngIf="agendamentoForm.get('complexidade')?.errors?.['required']">complexidade obrigatória.</span>
          </div>
        </div>

        <div class="col-md-6">
          <label for="periodoVisita" class="form-label">Período da Visita</label>
          <select
            id="periodoVisita"
            class="form-select"
            formControlName="periodoVisita"
          >
            <option value="">Selecione um período</option>
            <option *ngFor="let option of periodoOptions" [value]="option.valorMaximo">
              {{ option.valorMaximo }}
            </option>
          </select>
        </div>

        <div class="col-md-6">
          <label for="idFuncionario" class="form-label">Funcionário Responsável</label>
          <select
            id="idFuncionario"
            class="form-select"
            formControlName="idFuncionario"
          >
            <option [ngValue]="null">Selecione um funcionário</option>
            <option *ngFor="let func of funcionarios" [ngValue]="func.id">
              {{ func.nome }} {{ func.sobrenome }}
            </option>
          </select>
        </div>

        <div class="col-md-6">
          <label for="idOrcamento" class="form-label">Orçamento</label>
          <div class="input-group">
            <input
              id="idOrcamento"
              class="form-control"
              type="text"
              [value]="orcamentoSelecionado ? (orcamentoSelecionado.id + ' - ' + orcamentoSelecionado.nomeCliente) : ''"
              placeholder="Selecione um orçamento"
              readonly
              style="background-color: #e9ecef;"
            >
            <button class="btn btn-outline-secondary" type="button" (click)="incluirOrcamento()">
              <i class="bi bi-search"></i> Buscar
            </button>
          </div>
        </div>

        <div class="col-md-6">
          <label for="dataConclusao" class="form-label">Data de Conclusão</label>
          <input
            id="dataConclusao"
            class="form-control"
            type="datetime-local"
            formControlName="dataConclusao"
            readonly
            style="background-color: #e9ecef;"
          >
        </div>

        <div class="col-md-12" hidden>
          <label for="nomeRazaoSocial" class="form-label">Nome / Razão Social</label>
          <input
            id="nomeRazaoSocial"
            class="form-control"
            type="text"
            formControlName="nomeRazaoSocial"
            readonly
            style="background-color: #e9ecef;"
            placeholder="Preenchido automaticamente ao selecionar o cliente"
          >
        </div>
      </div>
    </div>

    <div class="form-section">
      <h3>Descrição</h3>
      <div class="row g-3">
        <div class="col-md-12">
          <label for="descricao" class="form-label">Descrição <span class="text-danger">*</span></label>
          <textarea
            id="descricao"
            class="form-control"
            rows="3"
            formControlName="descricao"
            [attr.aria-describedby]="'descricaoContador'"
            [class.is-invalid]="agendamentoForm.get('descricao')?.invalid && agendamentoForm.get('descricao')?.touched"
          ></textarea>
          <div id="descricaoContador" class="field-counter">
            <span [class.counter-pendente]="descricaoCaracteresFaltantes > 0" [class.counter-ok]="descricaoCaracteresFaltantes === 0">
              <ng-container *ngIf="descricaoCaracteresFaltantes > 0">
                Faltam {{ descricaoCaracteresFaltantes }}
                {{ descricaoCaracteresFaltantes === 1 ? 'caractere' : 'caracteres' }}
                para atingir o mínimo de {{ descricaoMinLength }}.
              </ng-container>
              <ng-container *ngIf="descricaoCaracteresFaltantes === 0">
                Mínimo de {{ descricaoMinLength }} caracteres atingido.
              </ng-container>
            </span>
            <span class="counter-total">{{ descricaoLength() }} caracteres</span>
          </div>
          <div class="invalid-feedback" *ngIf="agendamentoForm.get('descricao')?.invalid && agendamentoForm.get('descricao')?.touched">
            <span *ngIf="agendamentoForm.get('descricao')?.errors?.['required']">Descrição obrigatória.</span>
            <span *ngIf="agendamentoForm.get('descricao')?.errors?.['minlength']">Mínimo de {{ descricaoMinLength }} caracteres.</span>
          </div>
        </div>
      </div>
    </div>
  </form>

  <footer class="action-bar">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
    <button type="submit" form="agendamentoForm" class="btn btn-primary" [disabled]="isSubmitting">
      Salvar
    </button>
  </footer>
</section>
